import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Download, CheckCircle2 } from "lucide-react";
import { useLang } from "../components/Layout";
import { Reveal, Label, OutlineLink } from "../components/Reveal";
import { PDFS } from "../i18n";

const MerciPage = () => {
  const { lang, t } = useLang();
  useEffect(() => {
    document.title = t.pageTitles.merci;
    document.documentElement.lang = lang;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", t.pageDescs.merci);
  }, [lang, t]);

  const pdfs = PDFS[lang];

  return (
    <section data-testid="merci-page" className="pt-40 pb-24 md:pb-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal y={24}>
          <div className="flex items-center gap-4">
            <CheckCircle2 size={28} className="text-brand-gold" />
            <Label testId="merci-label">{t.merci.label}</Label>
          </div>
          <h1 className="mt-6 max-w-3xl font-serif text-4xl sm:text-6xl font-light leading-[1.08] text-white">
            {t.merci.title}
          </h1>
          <p className="mt-8 max-w-2xl text-base md:text-lg font-light leading-relaxed text-white/60">
            {t.merci.sub}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-16 border-t border-white/10 pt-12">
            <Label testId="merci-downloads-label">{t.merci.downloadsLabel}</Label>
            {pdfs ? (
              <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {pdfs.map((url, i) => (
                  <a
                    key={url}
                    data-testid={`merci-download-${i + 1}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-between gap-4 border border-white/10 bg-brand-surface p-6 transition-all duration-300 hover:border-brand-gold/50 hover:-translate-y-0.5"
                  >
                    <div>
                      <p className="text-sm font-light text-white">{t.kit.tools[i].name}</p>
                      <p className="mt-1 text-xs font-light text-white/40">{t.kit.tools[i].tag}</p>
                    </div>
                    <Download size={18} className="shrink-0 text-brand-gold transition-transform duration-300 group-hover:translate-y-0.5" />
                  </a>
                ))}
              </div>
            ) : (
              <p data-testid="merci-fr-note" className="mt-8 max-w-xl text-sm font-light leading-relaxed text-white/60">
                {t.merci.frOnlyNote}
              </p>
            )}
            <p data-testid="merci-note" className="mt-10 text-xs font-light text-white/40">{t.merci.note}</p>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-16">
            <OutlineLink testId="merci-back-home" to={`/${lang}/`}>
              {t.merci.backHome}
            </OutlineLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default MerciPage;
